import { Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AdminEventAnalyticsOverviewBarGraphsComponent } from '@pages/admin/admin-event-analytics/admin-event-analytics-overview/admin-event-analytics-overview-bar-graphs/admin-event-analytics-overview-bar-graphs.component';
import { EventKpiCardComponent } from '@shared/components/event-kpi-card/event-kpi-card.component';
import { EVENT_ANALYTICS_OVERVIEW_KPI_CARDS } from '../admin-event-analytics.constants';
import { AdminEventAnalyticsStore } from '../admin-event-analytics.store';
import { IOverviewCard } from './admin-event-analytics-overview.interface';

@Component({
  imports: [AdminEventAnalyticsOverviewBarGraphsComponent, EventKpiCardComponent, TranslateModule],
  selector: 'app-admin-event-analytics-overview',
  templateUrl: './admin-event-analytics-overview.component.html',
})
export class AdminEventAnalyticsOverviewComponent {
  public readonly store = inject(AdminEventAnalyticsStore);

  public readonly cards = computed<IOverviewCard[]>(() => {
    const kpis = this.store.kpis$();
    const compareKpis = this.store.compareKpis$();

    return EVENT_ANALYTICS_OVERVIEW_KPI_CARDS.map(
      (config): IOverviewCard => ({
        comparedCurrentValue: kpis && compareKpis ? config.getValue(compareKpis) : null,
        config,
        currentValue: kpis ? config.getValue(kpis) : null,
        totalValue: kpis && config.getTotal ? config.getTotal(kpis) : null,
      }),
    );
  });
}
